<template>
    <div id="identify">
        <popup ref="popup" type="center" @close="popClose">
            <div class="identifyPopup_con">
				<div class="popup_title">人工验证</div>
				<div class="popup_con">
					<div class="identify_code">
						<img class="code_img" :src="codeSrc" />
						<div class="change_code" @click="changeCode">换一张</div>
					</div>
					<div class="indentify_input">
						<div class="input_label">验证码：</div>
						<input class="input_ele" v-model="code" type="text" />
					</div>
					<button @click="validate" class="identify_btn">验证</button>
				</div>
			</div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        data() {
            return {
                code:"",
				defaultCodeSrc:`${API_SERVER}/api/front/auth/imagecode/`,
				codeSrc:`${API_SERVER}/api/front/auth/imagecode/`
            }
        },
        created() {
			this.changeCode()
        },
        methods: {
			init(){
				this.code = ""
			},
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
            },
            changeCode(){
				let token = localStorage.getItem("token")
				this.codeSrc = `${this.defaultCodeSrc}?token=${token}&t=${new Date().getTime()}`;
			},
			validate(){
				if(this.code){
					this.$emit("validate",this.code);
				}else{
                    this.$toast("请输入验证码");
				}
			}
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .identifyPopup_con{
		width: 400px;
		background-color: #fff;
        padding-bottom: 30px;
		border-radius: 10px;
		.popup_title{
			font-size: 26px;
			line-height: 68px;
			text-align: center;
		}
		.popup_con{
			padding-top: 36px;
			.identify_code{
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 28px;
				.code_img{
					width: 100px;
					height: 30px;
					display: block;
					margin-right: 20px;
				}
				.change_code{
					cursor: pointer;
					font-size: 16px;
					color: #476259;
					line-height: 30px;
				}
			}
			.indentify_input{
				display: flex;
				padding: 0 30px;
				.input_label{
					font-size: 16px;
					color: #999;
					line-height: 40px;
					white-space: nowrap;
				}
				.input_ele{
					flex-grow: 1;
					border: 1px solid #cecece;
					border-radius: 4px;
					padding: 0 12px;
					font-size: 16px;
					height: 40px;
                    width: 1px;
					background-color: transparent;
				}
			}
			.identify_btn{
				width: 240px;
				height: 40px;
                border-radius: 6px;
				margin: 28px auto 0;
				display: block;
				font-size: 16px;
				color: #fff;
                border: none;
				background-image: linear-gradient(#eb0006, #9c0703);
				&::after{
					content: none;
				}
			}
		}
	}
</style>